import React, { useState } from "react";
import timezones from "timezones-list";
import FormSelectInput from "./FormSelectInput";
import { Tooltip } from "antd";

const TimeZoneSelector = ({ values, setFieldValue }) => {
  const [openSelect, setOpenSelect] = useState(false);

  return (
    <>
      {/* {values?.userTimeZone && !openSelect ?
                <div className="vh-center gap-2">
                    <span role='button' onClick={() => setOpenSelect(true)}>{values?.userTimeZone}</span>
                    <Tooltip title={<span>Your timezone is <span className="fw-bold">{values?.userTimeZone}</span>.<br />If you want to change it, please select another timezone.</span>}>
                        <i className={`fas fa-question-circle text-info-color fs-5`} />
                    </Tooltip>
                </div>
                : <div style={{ width: 170 }}> */}
      <FormSelectInput
        label={null}
        showSearch
        placeholder="Timezone"
        containerProps={{ colon: false }}
        selectEleClassnames={"border-dark text-dark"}
        containerClassnames="mb-4"
        // size='small'
        value={values.userTimeZone}
        // error={errors.userTimeZone}
        // touched={touched.userTimeZone}
        options={timezones.map(({ label, tzCode }) => ({ label, value: tzCode }))}
        name="userTimeZone"
        // disabled={disable}
        onChange={e => {
          setFieldValue("userTimeZone", e);
        }}
        // selectProps={{
        //   onFocus: () => setOpenSelect(true),
        //   onBlur: () => setOpenSelect(false)
        // }}
      />
      {/* </div>
            } */}
    </>
  );
};

export default TimeZoneSelector;
